import AuthService from '../../AuthService';
const Banner = {
  getBanner(page){
    return AuthService.get(`banner/banner?page=${page}`);
  },
  showBanner(id){
    return AuthService.get(`banner/banner/${id}`);
  },
  createBanner(data){
    return AuthService.post(`banner/banner`,data);
  },
  updateBanner(id,data){
    return AuthService.put(`banner/banner/${id}`,data);
  },
  deleteBanner(id){
    return AuthService.delete(`banner/banner/${id}`);
  },
}
export default Banner
